module.exports = __webpack_public_path__ + "media/images/cz50-c29bf305e57382af8109f5e49f6261a4.svg";